<template>
  <v-app>
   <v-navigation-drawer
    style="z-index:1200"
    v-model="navdrawer"
    temporary
    absolute>

      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon large>account_circle</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-if="$store.state.jwtIsVerified">{{ this.$store.state.user.fullname }}</v-list-tile-title>
              <v-list-tile-title v-else>Guest</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile
          v-for="(item, index) in navitems"
          :key="'navbtn-' + index"
          v-if="!['admin-dashboard'].includes($route.name)"
          @click="navigateTo(item.routerName)">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

    </v-navigation-drawer>

    <v-toolbar app dark color="primary" class="fade-slide-in-from-top">
      <router-link to="/" class="nav-logo">
        <img src="https://warnerconnects.org/wp-content/uploads/2018/12/Warner-Connects-logo-outline-white.png">
      </router-link>
      <v-toolbar-title class="headline text-uppercase">
        <span>AUDIT</span>
        <span class="font-weight-light"> TOOL</span>
        <span
          v-if="['admin-dashboard'].includes($route.name)"
          class="grey--text font-weight-light"> ADMIN DASHBOARD</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="(item, index) in navitems"
          :key="'sidenavbtn-' + index"
          :to="item.link"
          :flat="!item.highlight"
          :color="(item.highlight) ? 'primary lighten-1' : ''"
          v-if="!['admin-dashboard'].includes($route.name) || item.icon === 'input'"
          @click="navigateTo(item.routerName)">
          <v-icon class="mr-1">{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-side-icon
        @click="navdrawer = true"
        class="hidden-md-and-up"></v-toolbar-side-icon>
    </v-toolbar>

    <div class="content-footer" :class="'route-' + $route.name">
      <v-content class="app-main-content">
        <transition name="fade-in">
        <router-view/>
        </transition>
      </v-content>
      <v-footer
        v-if="!['admin-dashboard', 'home', 'audit'].includes($route.name)"
        dark
        height="auto">
        <v-card
          class="flex"
          flat
          tile>
          <v-card-actions class="grey darken-3 justify-center" style="background-color: #FF595A !important">
            &copy;2019 &nbsp; <strong>Warner Connects</strong>
          </v-card-actions>
        </v-card>
      </v-footer>
    </div>

  </v-app>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      navdrawer: false,
    }
  },
  computed: {
    navitems () {
      let items = [
        { icon: 'info', title: 'About', routerName: 'about' },
        { icon: 'help', title: 'FAQ', routerName: 'faq' }
      ]
      if (this.$store.state.jwtIsVerified) {
        items.push(
          { icon: 'dashboard', title: 'Dashboard', routerName: 'user-dashboard' },
          { icon: 'assignment', title: 'Audit', highlight: true, routerName: 'audit' },
          { icon: 'input', title: 'Sign Out', routerName: 'sign-out' }
        )
      } else {
        items.push(
          { icon: 'input', title: 'Sign In', routerName: 'sign-in' },
          { icon: 'how_to_reg', title: 'Sign Up', highlight: true, routerName: 'sign-up' }
        )
      }
      return items
    }
  },
  methods: {
    navigateTo (routerName = 'home') {
      this.$router.push({ name: routerName })
    }
  },
  beforeMount () {
    console.log("this.$store.state.jwtIsVerified", this.$store.state.jwtIsVerified)
  },
  mounted () {
    // console.log("===", this.verifyJWT())
  },
}
</script>
<style lang="scss">

#app {
  background: linear-gradient(to right, #e4e5f1, #e4e5e6);
}
h1, h2, h3, h4, h5 {
  font-family: Roboto;
}
body .application {
  font-family: Helvetica;
}
/* app wide styles */
.nav-logo img {
  height: 50px;
  margin-top: 5px;
  color: var(--v-primary-base);
  /* background-color: var(--v-accent-lighten2); */
}
.v-overlay--active {
  z-index: 900;
}

.app-main-content {
  min-height: calc(100vh - 37px);
  // max-width: 1140px;
  margin: auto;
}
.content-footer.route-audit .app-main-content {
  min-height: calc(100vh);
}

.content-footer {
  overflow-y: auto;
  height: 100vh;
  outline: solid 1px red;
}

/* animations */
.fade-slide-in-from-top {
  animation: fadeInSlideInFromTop 0.3s ease-in;
}

@keyframes fadeInSlideInFromTop {
  from { opacity: 0; transform: translateY(-40%);  }
  to   { opacity: 1; transform: translateY(0%);  }
}


.fade-in-enter-active {
  transition: all .3s ease-in;
  transition-delay: .35s;
}
.fade-in-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-in-enter, .fade-in-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}


@media (max-width: 480px) {
  .nav-logo img {
    height: 45px;
  }
}


/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #999;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #777;
}
</style>